import { Http } from './http';
import { SurveyQuestion } from '@types';

class SurveyHttp extends Http {

  async getCreditSurvey(creditId: number): Promise<GetCreditSurveyResponse> {
    const res = await this.get<GetCreditSurveyResponse>(`/survey/${creditId}`);

    return res.data;
  }

  async getUserSurvey(userId: number): Promise<GetCreditSurveyResponse> {
    const res = await this.get<GetCreditSurveyResponse>(`/survey/user/${userId}`);

    return res.data;
  }

  async updateUserSurvey({
    userId,
    questionId,
    params,
    type = 'answer',
  }: UpdateUserSurveyParams): Promise<GetCreditAnswerResponse> {
    const res = await this.put<GetCreditAnswerResponse>(`/survey/user/${userId}/${type}/${questionId}`, params);

    return res.data;
  }

  async updateCreditSurvey({
    creditId,
    questionId,
    params,
    type = 'answer',
  }: UpdateCreditSurveyParams): Promise<GetCreditAnswerResponse> {
    const res = await this.put<GetCreditAnswerResponse>(`/survey/${creditId}/${type}/${questionId}`, params);

    return res.data;
  }

  async exportSurveyPDF(creditId: number, creditCode: string) {
    const filename = `${creditCode}_survey.pdf`;

    await this.downloadPdf(`question/${creditId}/download-report`, filename);
  }
}

export const surveyHttp = new SurveyHttp();

interface GetCreditSurveyResponse {
  surveyQuestions: SurveyQuestion[];
  answeredDate: Date;
  isFixed: boolean;
}

interface GetCreditAnswerResponse {
  surveyQuestions: SurveyQuestion;
  answeredDate: Date;
}

export interface CreditSurveyTableColProps {
  answerId?: number;
  customAnswer?: string;
}

export interface CreditSurveyTableRowProps {
  cols: CreditSurveyTableColProps[];
}

interface UpdateCreditSurveyParams {
  creditId: number;
  questionId: number;
  params: UpdateSurveyDTO;
  type?: UpdateCreditSurveyType;
}

interface UpdateUserSurveyParams {
  userId: number;
  questionId: number;
  params: UpdateSurveyDTO;
  type?: UpdateCreditSurveyType;
}

interface UpdateSurveyDTO {
  customAnswer?: string;
  answerIds?: number[];
  rows?: CreditSurveyTableRowProps[]
}

export type UpdateCreditSurveyType = 'answer-table' | 'answer' | 'answer-percent';
